/**
 * frontend/src/utils/texto.ts
 * ============================
 * Escapado y formateo de texto compartidos por todas las vistas.
 *
 * El escape de HTML se define una sola vez y en su versión más estricta. Con
 * una copia por componente es cuestión de tiempo que alguna se olvide de las
 * comillas, y una copia incompleta usada dentro de un atributo es un XSS
 * esperando su turno.
 */

/** Escapa texto para interpolarlo en HTML (contenido o atributos entre comillas dobles). */
export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/** Formatea un monto en pesos: -1234.5 → "-$1.234,50" (es-AR). */
export function fmtPesos(valor: number): string {
  const signo = valor < 0 ? "-" : "";
  const abs = Math.abs(valor).toLocaleString("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${signo}$${abs}`;
}
